import React from 'react';
export const links = [
  {
    id: 1,
    url: '#',
    text: 'home',
  },
  {
    id: 2,
    url: '#about',
    text: 'about',
  },
  {
    id: 3,
    url: '#project',
    text: 'projects',
  },
  {
    id: 4,
    url: '#contact',
    text: 'contact',
  },
];